import UserHelper from 'helpers/user';
import env from 'config/env'

const getGlobalSettings = () => [
    {
      title: 'WP Config',
      name: 'wp-config',
      desc: 'Updates constants inside the wp-config.php file for all websites globally.',
      icon: 'wpConfig',
      btnText: 'Manage'
    },
    {
      title: 'SMTP',
      name: 'smtp-mailer',
      desc: `Configure SMTP settings for all websites globally.`,
      icon: 'mailer',
      btnText: 'Manage'
    },
    UserHelper.isPartner() ? {
      title: 'WP Login 2FA',
      name: 'login-2fa',
      desc: `Configure WordPress login 2FA settings for all websites globally.`,
      icon: 'secure',
      btnText: 'Manage'
    } : null,
    {
      title: 'Nginx Config',
      name: 'nginx-config',
      desc: `Simplify Nginx settings for all websites globally.`,
      icon: 'nginx',
      btnText: 'Manage'
    },
    {
      title: 'Auto Updater',
      name: 'auto-updater',
      desc: `Control the auto-updater settings for all websites globally.`,
      icon: 'update',
      btnText: 'Manage'
    },
    UserHelper.isPartner() ? {
      title: 'Cloudflare',
      name: 'cloudflare',
      desc: 'Manage your Cloudflare integration and settings.',
      icon: 'cloudflare',
      btnText: 'Manage',
    } : null,
    UserHelper.isPartner() ? {
      title: 'SendGrid',
      name: 'sendgrid',
      desc: 'Manage your SendGrid integration and settings.',
      icon: 'sendgrid',
      btnText: 'Manage',
    } : null,
    UserHelper.isPartner() ? {
      title: 'Google Analytics',
      name: 'google-analytics',
      desc: 'Manage your Google Analytics integration and settings.',
      icon: 'googleAnalytics',
      btnText: 'Manage',
    } : null,
    {
      title: 'Deployment',
      name: 'deployment',
      desc: `Get more control over the new website deployment process.`,
      icon: 'deployed',
      btnText: 'Manage'
    },
    UserHelper.isPartner() ? {
      title: 'White Label',
      name: 'white-label',
      desc: `Customize the branding of the hosting plugin for your clients.`,
      icon: 'customize',
      btnText: 'Customize'
    } : null,
    UserHelper.isPartner() ? {
      title: 'Website Label Groups',
      name: 'website-label-groups',
      desc: `Categories website labels under groups with shared attributes.`,
      icon: 'label',
      btnText: 'Manage'
    } : null,
    UserHelper.hasAccessToBetaFeatures() ? {
      title: 'Remote Backup Storage',
      name: 'remote-backup-storage',
      desc: `Configure storage services for ${env.getBrandShortName()} to connect to and store your backups.`,
      icon: 'backup',
      btnText: 'Manage'
    } : null,
  ].filter(Boolean);

const PartnerHelper = {
    getGlobalSettings,
};

export default PartnerHelper;